import { render, staticRenderFns } from "./click-to-add.vue?vue&type=template&id=5678fde4&"
import script from "./click-to-add.vue?vue&type=script&lang=js&"
export * from "./click-to-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports